import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InventoryReportsLayer from "../components/InventoryReportsLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";


const InventoryReportsPage = () => {
    const hasPermission = usePermission("inventoryReports", "view");
    return (
        <>

            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Inventory Reports" />

                {/* Inventory Reports */}
                {hasPermission ? <InventoryReportsLayer /> : <AccessDeniedLayer />}

            </MasterLayout>

        </>
    );
};

export default InventoryReportsPage;
